<template>
  <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 0H5V9H4V0Z" fill="black" />
    <path d="M9 4L9 5L-4.37114e-08 5L0 4L9 4Z" fill="black" />
  </svg>
</template>

<script>
export default {
  name: "PlusIcon"
}
</script>
